import type { AddConversationMessage404Details } from './addConversationMessage404Details';
import type { AddConversationMessage404ErrorsItem } from './addConversationMessage404ErrorsItem';

/**
 * 통합 에러 응답 형식 - 모든 서비스에서 사용
 */
export type AddConversationMessage404 = {
  /**
   * 상세 에러 정보 (선택적)
   * @nullable
   */
  details?: AddConversationMessage404Details;
  /** 표준화된 에러 코드 */
  errorCode: string;
  /** 필드별 검증 에러 목록 (선택적) */
  errors?: AddConversationMessage404ErrorsItem[];
  /** 사용자에게 표시할 에러 메시지 */
  message: string;
  /** 요청 경로 (선택적) */
  path?: string;
  /** 요청 성공 여부 (항상 false) */
  success: boolean;
  /** 에러 발생 시간 */
  timestamp: string;
};
